import CreateOrderModal from "../modals/create-order";

export default {

    props: {
        copyConfig: {
            type: Object,
            required: true,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    methods: {
        showCreateOrder() {
            this.$modal.show(CreateOrderModal, { copyConfig: this.copyConfig, pages: this.pages }, { adaptive: true, classes: 'py-30', width: '996', height: 'auto', scrollable: true })
        },
    }
}
